import React, { useState, useEffect } from 'react';
import { authService } from '../services/authService';
import Layout from '../components/Layout';
import PasswordChangeModal from '../components/PasswordChangeModal';

export default function TargetedOutreach() {
  const [user, setUser] = useState(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const changePasswordParam = urlParams.get('changePassword');
    
    if (changePasswordParam === 'true') {
      const userStr = sessionStorage.getItem('signalcue_user');
      if (userStr) {
        const userData = JSON.parse(userStr);
        setUser(userData);
        if (userData.must_change_password) {
          setShowPasswordModal(true);
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          loadUserData();
        }
      } else {
        loadUserData();
      }
    } else {
      loadUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadUserData = async () => {
    try {
      const userData = await authService.getCurrentUser();
      if (!userData) {
        const loginUrl = process.env.REACT_APP_LOGIN_URL || (window.location.hostname.includes('-staging') ? window.location.origin : window.location.origin.replace('app.signalcue.ai', 'signalcue.ai'));
        window.location.href = `${loginUrl}/login`;
        return;
      }
      
      setUser(userData);
      
      if (userData.must_change_password) {
        setShowPasswordModal(true);
      }
    } catch (error) {
      console.error('Failed to load user:', error);
      const loginUrl = process.env.REACT_APP_LOGIN_URL || (window.location.hostname.includes('-staging') ? window.location.origin : window.location.origin.replace('app.signalcue.ai', 'signalcue.ai'));
      window.location.href = `${loginUrl}/login`;
    }
  };

  const handlePasswordChanged = async () => {
    const updatedUserData = await authService.getCurrentUser();
    if (updatedUserData) {
      setUser(updatedUserData);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Layout user={user}>
      {/* Password Change Modal */}
      {showPasswordModal && (
        <PasswordChangeModal
          user={user}
          onPasswordChanged={handlePasswordChanged}
          onClose={() => setShowPasswordModal(false)}
        />
      )}

      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Targeted Outreach</h2>
        <p className="text-gray-600">This page is coming soon.</p>
      </div>
    </Layout>
  );
}
